import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    PatientFormModificationsHistory: {
        background: 'transparent',
        borderRadius: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '.5rem',
    },
    PatientFormModificationsHistoryInfoContainer: {
        border: `1.5px solid ${theme.palette.lightGrey.half}`,
        borderRadius: '0.5rem !important',
        padding: 0,
    },
    PatientFormModificationsHistoryLast: {
        fontStyle: 'italic',
        display: 'flex',
        flexDirection: 'column',
        '& p': {
            paddingLeft: '1rem',
            paddingTop: '0.5rem',
        },
    },
    PatientFormModificationsHistoryRows: {},
    PatientFormModificationsHistoryRow: {
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        width: '100%',
        '& .MuiPaper-root': {
            '& .Mui-disabled': {
                opacity: 1,
            },
        },
        '& .Mui-expanded': {
            backgroundColor: '#FCFBFE !important',
        },
    },
    PatientFormModificationsHistoryRowAccordion: {
        width: '100%',
        backgroundColor: 'transparent !important',
        borderBottom: '1px solid #F5F4FB',
        '& .MuiPaper-root': {
            '& .Mui-disabled': {
                opacity: 1,
            },
        },
    },
    PatientFormModificationsHistoryMostRecentRowAccordion: {
        borderBottom: 'none',
    },
    PatientFormModificationsHistoryRowAccordionSummary: {
        borderBottom: 'none',
        padding: '12px 16px',
        minHeight: 'unset !important',
        '& .Mui-expanded': {
            margin: 'unset',
        },
        '& .MuiAccordionSummary-content': {
            display: 'flex',
            columnGap: '16px',
        },
    },
    PatientFormModificationsHistoryRowAccordionDetails: {
        padding: 'unset',
    },
    PatientFormModificationsHistoryAccordion: {
        background: 'transparent !important',
        margin: '0 !important',
        '&::before': {
            display: 'none',
        },
    },
    PatientFormModificationsHistoryAccordionSummary: {
        border: 'none',
        minHeight: 'unset !important',
        padding: '0',
        justifyContent: 'flex-start',
        '&:hover': {
            '& .MuiAccordionSummary-content': {
                textDecoration: 'none',
            },
        },
        '& .MuiAccordionSummary-content': {
            padding: '1rem',
            margin: '0 !important',
            flexGrow: 0,
            textDecoration: 'underline',
        },
    },
    PatientFormModificationsHistoryAccordionDetails: {
        display: 'flex',
        flexDirection: 'column',
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    PatientFormModificationsHistoryAccordionDetailsContent: {
        borderTop: '1px solid #F5F4FB',
        marginLeft: '1rem',
        marginRight: '1rem',
        padding: '12px 16px',
        paddingLeft: 'unset',
        display: 'flex',
        flexDirection: 'row',
        gap: '0.5rem',
        flexWrap: 'wrap',
        '& span': {
            backgroundColor: 'white',
            fontSize: '13px',
            lineHeight: '19px',
            fontWeight: 600,
            padding: '6px 8px',
            border: '1px solid #E5E9F2',
            borderRadius: '8px',
        },
    },
    PatientFormModificationsHistoryItem: {
        fontSize: '13px',
        color: theme.palette.typography.mediumDark,
        '& strong': {
            fontWeight: 600,
            color: theme.palette.typography.main,
        },
    },
    PatientFormModificationsHistoryItemAction: {
        width: '8rem',
        padding: '0.375rem 0.5rem !important',
        background: theme.palette.lightGrey.half,
        borderRadius: '.7rem',
        textAlign: 'center',
        fontWeight: 800,
        fontSize: '13px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}))
